<div class="modal-header">
  <h4 class="modal-title" i18n>Terms and conditions</h4>
  <button *ngIf="!noClose" type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" id="view-tnc">
  <div class="row g-3">
    <div *ngIf="tnc" class="col-md-12" [innerHTML]="tnc | translateField: 'customer_tnc'">
    </div>
  </div>
</div>
<div *ngIf="!noClose" class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
  <button *ngIf="showAccept" type="button" class="btn btn-primary" (click)="activeModal.close('accept')"
    i18n>Accept</button>
</div>